//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Bancos from '@/api/promotores/usuarios/bancos.api'
export default {
  data() {
    return {
      banco: {},
      loading: false,
    }
  },

  mounted() {
    this.loadBanco()
  },

  methods: {
    async loadBanco() {
      try {
        this.loading = true
        this.banco = await Bancos.get(this.$route.params.promotor)
      } finally {
        this.loading = false
      }
    },

    async submit() {
      try {
        this.loading = true
        await Bancos.update(this.$route.params.promotor, this.banco)
        this.$emit("submit", this.banco)
      } finally {
        this.loading = false
      }
    },
  },
}
